(ns frontend.test.search-selector.event
  (:require
   [frontend.controller.websocket.event :as ws]
   [frontend.test.search-selector.model :as m]
   [potpuri.core :as potpuri :refer [fn->]]
   [re-frame.core :as rf]
   [ui.fx.timeout :as timeout]))

(defn wrangle-os-results
  [response]
  (->> response
       :body
       :responses
       (mapcat (fn-> :hits :hits))
       (filterv :_id)
       (group-by :_id)
       (mapv (fn-> second first))
       (mapv (fn [{:keys [_id _source] :as hit}]
               (assoc hit
                 :id (parse-long _id)
                 :title (-> _source
                            :extras
                            :full-name))))
       (sort-by :_score)
       (group-by (fn-> :_source :original :entity/type keyword))
       (sort-by (fn [[_et hits]]
                  (->> hits
                       (mapv :_score)
                       (apply max 0.0)))
                >)))

(rf/reg-event-fx
 m/search-success
 (fn [{:keys [db] :as cofx} [_ args results-query response]]
   (let [current-query (get-in db (m/query-full-path args))
         ;; if results-query (query sent to backend) has not changed
         ;; => loading? as false

         ;;hits by entity-type:
         by-entity-type (wrangle-os-results response)
         new-db (cond-> db
                        true
                        (assoc-in (m/results-by-et-full-path args) by-entity-type)

                        true
                        (assoc-in (m/results-query-full-path args) results-query)

                        (= current-query results-query)
                        (potpuri/dissoc-in
                         (m/query-loading-full-path args)))]
     ;;(prn ">response" results-query response)
     {:db new-db})))

(rf/reg-event-fx
 m/search-error
 (fn [{:keys [db] :as cofx} [_ args response]]
   (let [new-db db]
     {:db new-db})))

(rf/reg-event-fx
 m/debounced-search
 (fn [{:keys [db]} [_ args]]
   (let [query (get-in db (m/query-full-path args))
         fuzzy? true                                                                                ;;(get-in (m/fuzzy-full-path args) db)
         new-db (-> db
                    (assoc-in (m/query-loading-full-path args) true))
         body {:id         :search/universal-search
               :body       {:query        query
                            :fuzzy?       fuzzy?
                            ;;:entity-types entity-indices/universal-entity-types
                            :entity-types [:entity.type/person
                                           :entity.type/company]}
               :on-success [m/search-success args query]
               :on-error   [m/search-error]}]
     {:db       new-db
      ::ws/send body})))

(rf/reg-event-fx
 m/search
 (fn [{:keys [db] :as cofx} [_ args val]]
   (let [new-db (-> db
                    (assoc-in (m/query-loading-full-path args) true)
                    (assoc-in (m/query-full-path args) val))]
     {:db new-db
      ::timeout/timeout
      {:id      (str "query-" (:ident args))
       :event   [m/debounced-search args]
       :wait-ms 300}})))

(rf/reg-event-fx
 m/update-query
 (fn [{:keys [db] :as cofx} [_ args val]]
   (let [new-db (cond-> db
                        (nil? val) (potpuri/dissoc-in (m/query-full-path args))
                        (some? val) (assoc-in (m/query-full-path args) val)
                        (some? val) (assoc-in (m/query-loading-full-path args) true))]
     {:db new-db
      ::timeout/timeout
      {:id      (str "query-" (:ident args))
       :event   [m/debounced-search args]
       :wait-ms 1000}})))
